import { NgModule } from '@angular/core';
import { PathResolveService } from '../app/services/path-resolve/path-resolve-service.service';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { paths } from './app-paths';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: paths.home }, 
  { path: paths.home,  loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule) },
  { path: 'admin', loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule) },
  { path: paths.privacy, loadChildren: () => import('./features/legal/privacy/privacy.module').then(m => m.PrivacyModule) },
  { path: paths.cookies, loadChildren: () => import('./features/legal/cookies/cookies.module').then(m => m.CookiesModule) },
  { path: paths.contactus, loadChildren: () => import('./features/legal/contact-us/contact-us.module').then(m => m.ContactUsModule) },
  { path: paths.firebaseinfo, loadChildren: () => import('./features/firebase-info/firebase-info.module').then(m => m.FirebaseInfoModule) },
  { path: 'login', loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule) },
  { path: "**", resolve: { path: PathResolveService }, component: NotFoundComponent },
  // { path: "**", resolve: { path: PathResolveService }, component: NotFoundComponent },
  // { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }


/*
  { path: '', pathMatch: 'full', redirectTo: paths.home },
*/
